import {
  exceptFilterKey,
  requestTypeMap,
  cityOptionsMap,
  cityValuesMap,
  CityAndAreaKeyMap,
} from './utils'
import { i18n } from '@/common/utils/i18n'
import VueI18n from '@/i18n/locale'

export default {
  filterValues(state) {
    const currentTab = state.currentTab
    const filterValue = state.filterValue || {}
    const lists = state.lists || {}
    const params = { ...filterValue }

    // --- 特殊逻辑
    params.requestType = requestTypeMap[currentTab]
    params.pageNo = (lists[currentTab] || {}).pageNo || params.pageNo
    // params.pageSize = (lists[currentTab] || {}).pageSize || params.pageSize
    // --- 排除逻辑
    const exceptKey = exceptFilterKey[currentTab] || []
    exceptKey.forEach(key => {
      delete params[key]
    })
    // start --- 城市参数特殊逻辑
    const keys = cityValuesMap[currentTab] || []
    for (const key in params) {
      if (keys.includes(key)) {
        params[CityAndAreaKeyMap[key]] = filterValue[key]
      }
    }
    delete params.AreaCityId
    delete params.AreaAreaIds
    // end --- 城市参数特殊逻辑
    return params
  },
  MoreFilterOption(state) {
    const currentTab = state.currentTab
    const filterOptions = state.filterOptions || {}
    const selectors = [
      {
        label: VueI18n.t('FoodB_list_Name_of_dxYm' /** 销售姓名 */),
        key: 'notMyStore',
        col: 1,
        multiple: false,
        options: filterOptions.notMyStore,
      },
      {
        label: i18n.gettext('签约状态'),
        key: 'status',
        col: 2,
        options: filterOptions.status.map(item => ({
          ...item,
          label: item.label,
          /**
          label:
            currentTab === TabNames.my.key
              ? `${item.label}(${item.count || 0})`
              : item.label
         */
        })),
      },
      {
        label: VueI18n.t('Gattaran_V20__eJGq' /** 商机等级 */),
        key: 'potential',
        col: 3,
        options: filterOptions.potential,
      },
      {
        label: VueI18n.t('Gattaran_V20__THMR' /** 商户等级 */),
        key: 'rPerformance',
        col: 3,
        options: filterOptions.rPerformance,
      },
      {
        label: VueI18n.t('FoodB_Commision_Type_of_EIWZ' /** 商户类型 */),
        key: 'type',
        col: 3,
        options: filterOptions.type,
      },
      {
        label: i18n.gettext('经营状态'),
        key: 'bizStatus',
        col: 1,
        options: filterOptions.bizStatus,
      },
      {
        label: VueI18n.t('FoodD_Storefront_YFcS_cnUy' /** Storefront */),
        key: 'storeFrontStatus',
        col: 3,
        multiple: false,
        options: filterOptions.storeFrontStatus,
      },
      {
        label: 'Priority',
        key: 'priority',
        col: 2,
        options: filterOptions.priority,
      },
    ]

    const exceptKey = exceptFilterKey[currentTab] || []

    return selectors.filter(item => {
      return !exceptKey.includes(item.key)
    })
  },
  currentListItems(state) {
    const currentTab = state.currentTab
    const lists = state.lists || {}
    return lists[currentTab] || { data: [], total: 0, pageNo: 1, pageSize: 20 }
  },

  citiesOptions(state) {
    const currentTab = state.currentTab
    const filterOptions = state.filterOptions || {}
    return filterOptions[cityOptionsMap[currentTab]]
  },
}
